<template> 
<!-- https://codepen.io/dragos193/pen/PdxwjN -->
<b-card no-body>
  <b-container>
    <!-- <b-card class="page403" no-body> -->
        <b-card-body id="page403">

            <div class="error">
              <b-container class="container">
                <b-row>
                  <b-col class="column lockBtn">
                    <i class="fa fa-lock"></i>
                  </b-col>
                  <b-col class="column">
                    <h3>you don't have permission to view this page.</h3>
                    <h5>hit the request access button and we'll find someone who can give you access</h5>  
                  </b-col>
                  <b-col class="column">
                      <b-button class="button" block variant="outline-primary" v-on:click="routerBack()">
                      <span>Back</span>
                      </b-button>
                 </b-col>
               </b-row>
              </b-container>
            </div>
        </b-card-body>
    <!-- </b-card> -->
    </b-container>
</b-card>

</template>

<script>
import Vue from "vue";
export default {
  name: 'Page403',
  methods: {
    routerBack(){
      this.$router.go(-1);
    },
  },
  computed:{    
    
  }
}
</script>


<style scoped>
.container{
  margin: 5%;
}
.column{
  float: none;
  flex-basis: auto !important;
  margin: auto auto;
  /* display: flex; */
  text-align: center !important;;
}
.fa-lock {
  animation-iteration-count: 2;
  margin-top: auto;
  /* animation: vanishIn; */
  /* transform: translateZ(1px); */
  position: absolute;
  display: inline-block;
  width: 51px;
  height: 51px;
  border-radius: 30%;
  margin: 6px;
  /* background: #fff; */
  animation: square 4s cubic-bezier(0, 0.5, 0.2, 2) infinite;
}
.container {
    width: 100%;
    padding-right: auto !important;
    padding-left: auto !important;
    margin-right: auto !important;
    margin-left: auto !important;
}
 .fa-lock {
   position: absolute;
   /* top: 80%; */
   /* left: 50%; */
   transform: translate(-50%, -50%);
   font-size: 100px;
   transition: all 0.3s;
   animation: bounceAround 1.1s ease-in-out infinite;
}
 
.text-error{
   margin: auto;
}
 .fa-lock:hover {
   color: #ff0000;
}
 h3{
   margin: 130px 0;
   margin-bottom: 30px;
   text-transform: uppercase;
}
 h5 {
   margin-top: 0px 0;
   margin-bottom: 100px;
}
body,
html {
    padding: 200px;
    margin: 0;
    font-family: 'Quicksand', sans-serif;
    font-weight: 400;
    overflow: hidden;
}
.error {
    text-align: center;
    top: 100%;
}
.error h1 {
    font-size: 125px;
    padding: 0;
    margin: 0;
    font-weight: 700;
}
.error h2 {
    margin: -30px 0 0 0;
    padding: 0px;
    font-size: 47px;
    letter-spacing: 12px;
}
.card {
    -webkit-animation: .5s ease-in-out 1s forwards;
            animation: .5s ease-in-out 1s forwards;
    /* position: absolute; */
}
@media screen and (max-width: 1000px) {
    .container {
      -webkit-transform: scale(.85);
              transform: scale(.85);
    }
  }
  @media screen and (max-width: 850px) {
    .container {
      -webkit-transform: scale(.75);
              transform: scale(.75);
    }
  }
  @media screen and (max-width: 775px) {
    .container {
      -ms-flex-wrap: wrap-reverse;
          flex-wrap: wrap-reverse;
      -webkit-box-align: inherit;
          -ms-flex-align: inherit;
              align-items: inherit;
    }
  }
  @media screen and (max-width: 370px) {
    .container {
        -webkit-transform: scale(.6);
                transform: scale(.6);
      }
  }
  /* Button */
  .button {
    margin: 0 0 0px;
    /* color: #a91d57; */
    font-size: 16px;
    font-weight: bold;
    background-color: white;
    /* background-image: linear-gradient(90deg, #FEE140 0%, #FA709A 100%);   */
    padding: 10px 30px;
    border-radius: 10px;
    animation: button 2s  infinite;
    /* animation: pulse 1.5s 0.3s ; */
    width: 30%;
    text-align: center;
    margin-top: auto;
    display: inline-block;
  }
  .button:hover {
    cursor: pointer;
  }
@keyframes button {
  50% {
    transform: matrix3d(1, 0, 0, 0, 0, 1, 0, 0.003, 0, 0, 1, 0, 0, 0, 0, 1);
  }
  75% {
    transform: matrix3d(1, 0, 0, 0, 0, 1, 0, 0.003, 0, 0, 1, 0, 0, 0, 0, 1);
  }
}
 
</style>